import { fetchDeviceConfigurationQuery } from '../data/configuration/fetchDeviceConfigurationQuery';

import { updateRhinoConfig } from './rhinoConfig';
import { InitRhinoArgs } from './type';

export function initRhino({ applicationParams, isDebug = false, udid }: InitRhinoArgs) {
  updateRhinoConfig((state) => ({ ...state, isDebug }));

  return fetchDeviceConfigurationQuery({ ...applicationParams, udid });
}
